import { createConfigLoader } from "@/config";

export interface IPageConfig {
  // Home
  home: string;

  // Search
  developers: string;
  buy: string;
  rent: string;

  // Static pages
  about: string;
  owners: string;
  promotions: string;
  contacts: string;

  goldenVisa: string;

  // Auth
  login: string;
  registration: string;
  recovery: string;
  resetPassword: string;

  // Favorites for guests
  favorite: string;

  // Profile for users
  profile: {
    main: string;
    myProfile: string;
    myObjects: string;
    favorites: string;
    subscriptions: string;
    savedSearches: string;
    settings: string;
    addObject: string;
  };

  privacyPolicy: string;
}

export interface IPagesConfig {
  pages: IPageConfig;
}

// Default pages configuration
const defaultPagesConfig: IPagesConfig = {
  pages: {
    // Home
    home: "/",

    // Search
    developers: "/developers",
    buy: "/buy",
    rent: "/rent",

    // Static pages
    about: "/about",
    owners: "/#owners",
    promotions: "/#promotions",
    contacts: "/#contacts",

    goldenVisa: "/golden-visa",

    // Auth
    login: "/login",
    registration: "/registration",
    recovery: "/recovery-password",
    resetPassword: "/reset-password",

    // Favorites for guests
    favorite: "/favorite",

    // Profile for users
    profile: {
      main: "/profile",
      myProfile: "/profile",
      myObjects: "/profile/objects",
      favorites: "/profile/favorites",
      subscriptions: "/profile/notifications",
      savedSearches: "/profile/search",
      settings: "/profile/settings",
      addObject: "/profile/add-object",
    },

    privacyPolicy: "/privacy-policy",
  },
};

// Load configuration with country-specific overrides
const pagesConfigData = createConfigLoader(defaultPagesConfig, "pages");

// Export for backward compatibility
export const pageConfig = pagesConfigData.pages;
